import {Form, FormInstance, Select} from 'antd'
import React from 'react'
import {useIntl} from 'react-intl'

export type ProjectFormDropdownProps = {
  projectsList: {id: number; name: string}[]
  fieldName?: string
  preventFormCloseDueToModification: () => void
  disabled?: boolean
  extra?: React.ReactNode
}

export function ProjectFormDropdown({
  projectsList,
  fieldName = 'projectId',
  preventFormCloseDueToModification,
  disabled,
  extra,
}: ProjectFormDropdownProps) {
  const intl = useIntl()

  return (
    <Form.Item name={fieldName} label={intl.formatMessage({id: 'project'})} extra={extra}>
      <Select
        allowClear
        disabled={disabled}
        onChange={preventFormCloseDueToModification}
        options={projectsList.map((project) => ({
          label: project.name,
          value: project.id,
        }))}
      ></Select>
    </Form.Item>
  )
}
